var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Pager from '../Pager';
import _ from "lodash";
var Pagination = (function (_super) {
    __extends(Pagination, _super);
    function Pagination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.page = 1;
        _this.psize = 20;
        _this.currentPage = 1;
        _this.isTenLimit = false;
        return _this;
    }
    Pagination.prototype.created = function () {
        this.pager = new Pager();
        this.pager.setLimit(this.size);
        this.psize = this.size ? this.size : 20;
        this.pageSizes = this.pageSizes ? this.pageSizes : [10, 20, 50, 100, 300, 500, 1000];
        this.isTenLimit = (this.pageSizes && this.pageSizes.length == 1 && this.pageSizes.indexOf(10) > -1) ? true : false;
    };
    Pagination.prototype.handleSizeChange = function (size) {
        this.psize = size;
        this.currentPage = 1;
        this.page = 1;
        this.pager.setLimit(size).resetStart();
        this.change();
    };
    Pagination.prototype.handleCurrentChange = function (page, isSearch) {
        this.pager.setPage(page);
        this.page = page;
        this.currentPage = page;
        if (!isSearch) {
            this.change();
        }
    };
    Pagination.prototype.getPage = function () {
        return this.pager.getPage(this.isTenLimit);
    };
    Pagination.prototype.clear = function () {
        var currentLimit = this.pager.getPage().limit;
        this.currentPage = 1;
        this.pager.clear();
        this.pager.setLimit(currentLimit);
        this.psize = currentLimit;
        this.$refs.paging.internalPageSize = currentLimit;
    };
    __decorate([
        Prop({
            type: Number,
            required: true
        })
    ], Pagination.prototype, "total", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 20
        })
    ], Pagination.prototype, "size", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () { return [10, 20, 50, 100, 300, 500, 1000]; }
        })
    ], Pagination.prototype, "pageSizes", void 0);
    Pagination = __decorate([
        Component({
            methods: {
                change: _.debounce(function () {
                    var that = this;
                    that.$emit("change", that.pager.getPage());
                })
            },
            watch: {
                size: function (newVal, oldVal) {
                    this.psize = newVal;
                }
            }
        })
    ], Pagination);
    return Pagination;
}(Vue));
export default Pagination;
